import { useState } from "react";
export const useBookingLocationState = (
  pickupInit: string,
  dropoffInit: string
) => {
  const [pickupLocation, setPickupLocation] = useState<string>(pickupInit);
  const [reservationDestination, setReservationDestination] =
    useState<string>(dropoffInit);

  return {
    pickupLocation,
    setPickupLocation,
    reservationDestination,
    setReservationDestination,
  };
};
